import React from "react";
import cssFooter from "./CSS/footer.module.css";
import { mapSelector } from "../../Functions/MapSelector";
import {
    BUSINESS_PHONE_FORMATTED,
    BUSINESS_PHONE_LINK,
    BUSINESS_ADDRESS_FULL,
    BUSINESS_EMAIL_LINK
} from "../../Aux/businessInfo";
import { getTodayName, getTodayStatus, isClosedToday } from "../../Functions/timeUtils";

const Footer = () => {
    const today = getTodayName();
    const status = getTodayStatus();
    const isClosed = isClosedToday();

    return (
        <div>
            <div className={cssFooter.mobileSpace}><p> blank </p></div>
            <div className={cssFooter.mainPageBottom}/>

            <div className={cssFooter.footerContainer}>
                <div className={cssFooter.grid}>
                    <div>
                        <span className={cssFooter.visibleBig}>
                            <a href={BUSINESS_PHONE_LINK}>{BUSINESS_PHONE_FORMATTED}</a>
                        </span>
                        <span className={cssFooter.visibleSmall}>
                            <a href={BUSINESS_PHONE_LINK}>Call</a>
                        </span>
                    </div>
                    <div title="Open Map" className={cssFooter.address} onClick={() => mapSelector()}>
                        <span className={cssFooter.visibleBig}>{BUSINESS_ADDRESS_FULL}</span>
                        <span className={cssFooter.visibleSmall}>Map</span>
                    </div>
                    <div>
                        <span className={cssFooter.visibleBig}>
                            <span>{today}: <span className={isClosed ? cssFooter.closed : null}>{status}</span></span>
                        </span>
                        <span className={cssFooter.visibleSmall}>
                            <a href={BUSINESS_EMAIL_LINK}>Email</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
